<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div>
    <div class="card bg-light m-2">
      <center>
        <h4 v-if="associatedIrrs.length" class="card-header">This resource is published in the following registries</h4>
        <h4 v-else class="card-header">This resource is <span class="font-weight-bold">not currently published</span></h4>
      </center>
      <div class="card-body">
        <div class="card-text">
          <div v-if="associatedIrrs.length" v-html="createIrrList()"></div>
          <div v-else-if="existingData.isComplete">
            <p class="lead">
              To be <span class="font-weight-bold">DISCOVERABLE</span> by users of our <a href="/discovering-iot" target="_blank">IoT Assistant mobile app</a>, a resource has to be published. Use the Publish button to submit your resource description for publication in one or more registries, or to self-publish the resource..
            </p>
            <p>
              <!-- <a :href="publishUrl" class="btn btn-success">Publish</a> -->
            </p>
          </div>
          <div v-else>
            <p class="lead">
              To be <span class="font-weight-bold">DISCOVERABLE</span> by users of our <a href="/discovering-iot" target="_blank">IoT Assistant mobile app</a>, a resource has to be published. This resource has not been completed and can not be published.  Use the Edit button to complete your resource description.
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
    export default {
      props: {
        route: String,
        associatedIrrs: [Object, Array],
        existingData: [Object, Array],
      },
      data: function() {
        return {
          publishUrl: '/resource/' + this.existingData.id + '/publish/'
        }
      },
      methods: {
        createIrrList: function() {
          if(this.associatedIrrs.length) {
            var html = '';
            for(var i=0; i<this.associatedIrrs.length; i++) {
              html += '<a href="/irr/' + this.associatedIrrs[i].id + '/" class="lead font-weight-bold">' + this.associatedIrrs[i].name + '</a>';
              if(i+1 <this.associatedIrrs.length) { html += ',&nbsp;&nbsp;&nbsp;'; }
            }
            return html;
          }
          return 'None';
        },
      },
      mounted() {
        //
      }
    }
</script>
